import { SurveyReportPage } from "./surveyReportPage";

export const SurveyReports = SurveyReportPage;
